export type WealthInboundContactSyncSettingsFilters = {
  active?: boolean
  contactType?: string
  tags?: string[]
}

export type WealthInboundContactSyncSettings = {
  autoSync: boolean
  filters: WealthInboundContactSyncSettingsFilters
}

export type WealthInboundSyncSettings = {
  contact: WealthInboundContactSyncSettings
}

export type WealthSettingsFormValues = {
  inbound: WealthInboundSyncSettings
}

export const wealthSettingsDefaultValues: WealthSettingsFormValues = {
  inbound: {
    contact: {
      autoSync: false,
      filters: {},
    },
  },
}
